import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const api = {
  health: () => client.get('/health').then((r) => r.data),

  // public
  submitLead: (payload) => client.post('/leads', payload).then((r) => r.data),

  // auth
  hasAdmin: () => client.get('/auth/has-admin').then((r) => r.data),
  login: (email, password) => client.post('/auth/login', { email, password }).then((r) => r.data),
  logout: () => client.post('/auth/logout').then((r) => r.data),
  me: () => client.get('/auth/me').then((r) => r.data),
  changePassword: (current_password, new_password) => client.post('/auth/change-password', { current_password, new_password }).then((r) => r.data),

  // leads admin
  listLeads: (params = {}) => client.get('/leads', { params }).then((r) => r.data),
  getLead: (id) => client.get(`/leads/${id}`).then((r) => r.data),
  updateLead: (id, body) => client.patch(`/leads/${id}`, body).then((r) => r.data),
  addNote: (id, text) => client.post(`/leads/${id}/notes`, { text }).then((r) => r.data),
  retryEmail: (id) => client.post(`/leads/${id}/retry-email`).then((r) => r.data),
  leadsSummary: () => client.get('/leads/summary').then((r) => r.data),
  exportCsv: () => `${API}/leads/export.csv`,

  // media
  listMedia: (params = {}) => client.get('/media', { params }).then((r) => r.data),
  uploadMedia: (formData) => client.post('/media/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data),
  updateMedia: (id, formData) => client.patch(`/media/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data),
  deleteMedia: (id) => client.delete(`/media/${id}`).then((r) => r.data),

  // settings
  getEmailSettings: () => client.get('/settings/email').then((r) => r.data),
  saveEmailSettings: (body) => client.post('/settings/email', body).then((r) => r.data),
  testEmail: (to) => client.post('/settings/email/test', to ? { to } : {}).then((r) => r.data),
  disconnectEmail: () => client.delete('/settings/email').then((r) => r.data),

  // audit
  listAudit: (params = {}) => client.get('/audit', { params }).then((r) => r.data),
};

export default client;
